module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [(_vm.name && _vm.hideName === false) ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.uniqueId
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('label.' + _vm.name)) + " "), (_vm.crequired) ? _c('small', [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.cache.dataReady) ? _c('div', {
    staticClass: "form-inline"
  }, [_vm._l((_vm.selection), function(i, tag) {
    return _c('div', {
      staticClass: "badge badge-primary tag mb-1 text-nowrap"
    }, [_c('div', {
      staticClass: "text-truncate",
      staticStyle: {
        "max-width": "150px",
        "display": "inline-block"
      }
    }, [_vm._v(_vm._s(_vm.categories[tag] ? _vm.categories[tag].name : _vm.$t('status.error')))]), _vm._v(" "), (!_vm.csingle) ? _c('i', {
      staticClass: "fa fa-close btn-tag",
      on: {
        "click": function($event) {
          _vm.setCategory(tag, false)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "col p-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autocompleteStub),
      expression: "autocompleteStub"
    }],
    staticClass: "form-control",
    class: {
      'is-danger': _vm.errors.length > 0
    },
    staticStyle: {
      "padding": "2px 0",
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "id": _vm.uniqueId,
      "placeholder": _vm.cplaceholder
    },
    domProps: {
      "value": (_vm.autocompleteStub)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.setCategory(_vm.filteredCategories[0], !_vm.selection[_vm.filteredCategories[0]]);
        _vm.autocompleteStub = '';
        _vm.expanded = false
      },
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46], $event.key)) { return null; }
        _vm.autocompleteStub == '' && _vm.setCategory(Object.keys(_vm.selection).slice(-1)[0], false)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.autocompleteStub = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "view-button-holder"
  }, [_c('button', {
    staticClass: "btn btn-link btn-small m-0",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.expanded = !_vm.expanded
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-down text-muted"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "completions-box card",
    class: {
      'expanded': _vm.autocompleteStub.length !== 0 || _vm.expanded
    }
  }, [_c('category-recursive', {
    attrs: {
      "category-id": 0,
      "only-filtered": !_vm.expanded,
      "filtered-ids": _vm.filteredCategories,
      "selection": _vm.selection
    },
    on: {
      "selected": function($event) {
        _vm.setCategory($event.id, $event.value);
        _vm.autocompleteStub = '';
        _vm.expanded = false
      }
    }
  }), _vm._v(" "), (_vm.filteredCategories.length === 0 && !_vm.expanded) ? _c('div', {
    staticClass: "text-muted text-center font-italic"
  }, [_vm._v("\n\t\t\t\t\t(няма резултати)\n\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.errors), function(error) {
    return _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.length > 0),
        expression: "errors.length > 0"
      }],
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(error))])
  })], 2)], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4524a7a7!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/base/category/f-category.vue
// module id = 651
// module chunks = 1